module.exports = __webpack_public_path__ + "img/logo.5c61d6bf.svg";